import * as S from './styles'
import { Table, TableContainer, Tbody, Thead, Tr, Text, Button, Input, useToast, Spinner } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import Header from '../../../components/Header'
import { Flex } from '@chakra-ui/layout'
import axios from 'axios'
import { useEffect, useState } from 'react'
import { firstLetterUpperCaseAndRestLowerCase } from '../../../utils/capitalFirstLetter'
import { formatDate } from '../../../utils/formatDate'
import { usePdfGenerator } from '../../../hooks/usePdfGenerator'
import { Filtro } from './Filtro'
import { Row } from './Row'
import { Td } from '@chakra-ui/table'
import { api } from '../../../services/api'
import { user } from '../../../helpers/user'
import { OpsLiberadas } from './OpsLiberadas'

export function OrdemProducao() {
  const [data, setData] = useState([])
  const [checkoutItem, setCheckoutItem] = useState([])
  const [loading, setLoading] = useState(false)
  const [loadingCheckoutAllItems, setLoadingCheckoutAllItems] = useState(false)
  const [infoModalOps, setInfoModalOps] = useState(null)

  const toast = useToast()

  console.log('data', data)

  function handleCheckoutItem(item) {
    const itemExists = checkoutItem.find((checkoutItem) => checkoutItem.id === item.id)

    if (itemExists) {
      const filteredCheckoutItem = checkoutItem.filter((checkoutItem) => checkoutItem.id !== item.id)
      setCheckoutItem(filteredCheckoutItem)
    } else {
      setCheckoutItem([...checkoutItem, item])
    }
  }

  async function handleCheckoutAllItems() {
    setLoadingCheckoutAllItems(true)

    if (checkoutItem.length === data.length) {
      setCheckoutItem([])
      setData(data.map((item) => ({ ...item, checked: false })))
      setLoadingCheckoutAllItems(false)
      return
    }

    const allItems = data.map((item) => {
      return {
        ...item,
        checked: true,
      }
    })

    console.log(allItems)
    setCheckoutItem(allItems)
    setData(allItems)

    // await finalizeCheckout()

    setLoadingCheckoutAllItems(false)
  }

  async function finalizeCheckout() {
    const codUsu = user.codigo_usuario
    const existsItem = checkoutItem.length > 0

    if (existsItem) {
      try {
        const pedidos = checkoutItem.map((item) => item.numero_pedido)

        const params = {
          pedidos: pedidos,
          codigo_usuario: codUsu,
        }

        const response = await api.post('/site/v2/pedido/atualiza-pendencia-ordem-producao', params)

        console.log('response:', response)

        toast({
          title: 'Pedido finalizado com sucesso!',
          status: 'success',
          position: 'top-right',
          duration: 9000,
          isClosable: true,
        })
        setCheckoutItem([])
        getOrdemProduction({
          situacao: '3',
        })
        return
      } catch (error) {
        console.log('ERROR', error)
      }
    }

    toast({
      title: 'Selecione ao menos um item para finalizar o pedido!',
      status: 'error',
      position: 'top-right',
      duration: 9000,
      isClosable: true,
    })
  }

  const headData = [
    'Nº Pedido',
    'Empresa',
    'Ped Compra',
    'Vendedor',
    'Produto',
    'Cod. Prod',
    'Cor produto',
    'Qtd',
    'Gravação',
    'OBS OP',
    'Prazo',
    'Término Produção',
    'Layout Terceirizado',
  ]

  const mapBodyData = (data) => {
    return data.map((item) => [
      item.numero_pedido,
      item.nome_empresa || 'N/A',
      'Não tem',
      firstLetterUpperCaseAndRestLowerCase(item.nome_vendedor),
      'Não tem',
      item.codigo_produto,
      firstLetterUpperCaseAndRestLowerCase(item.cor_produto),
      item.qtd,
      item.gravacao,
      item.observacao !== '' ? item.observacao : 'Não tem',
      item.prazo_entrega,
      formatDate(item.data_saida, true),
      item.terceirizado ? 'Sim' : 'Não',
    ])
  }

  const generatePDF = usePdfGenerator(headData, mapBodyData, 'Ordem de produção')

  const flagDuplicates = (array) => {
    const counts = {}
    array.forEach((item) => {
      const key = `${item.codigo_produto}-${item.numero_pedido}-${item.nome_vendedor}`
      counts[key] = counts[key] ? counts[key] + 1 : 1
    })

    array.forEach((item) => {
      const key = `${item.codigo_produto}-${item.numero_pedido}-${item.nome_vendedor}`
      if (counts[key] > 1) {
        item.duplicate = true
      }
    })

    return array
  }

  async function getOrdemProduction(dados) {
    console.log('DADOS', dados)
    setLoading(true)
    const response = await api.post('/site/v2/fluxo-layout/listar-info-ordemprod')

    setInfoModalOps(response.data.dados)

    const itens = response?.data?.lista?.map((item, index) => {
      return {
        ...item,
        id: index,
      }
    })

    const itensComFlagDeDuplicatas = flagDuplicates(itens)

    setData(itensComFlagDeDuplicatas)
    setLoading(false)

    if (dados.numero_pedido) {
      const filteredData = itens.filter((item) => item.numero_pedido === dados.numero_pedido)
      setData(filteredData)
      return
    }

    if (dados.impressao) {
      const filteredData = itens.filter((item) => item.gravacao.toLowerCase().includes(dados.impressao.toLowerCase()))

      setData(filteredData)
      return
    }

    if (dados.data_entrada && dados.data_saida) {
      const filteredData = itens.filter(
        (item) => item.data_compra.substring(0, 10) >= dados.data_entrada && item.data_compra.substring(0, 10) <= dados.data_saida
      )
      setData(filteredData)
      return
    }

    if (dados.situacao) {
      const filteredData = itens.filter((item) => item.situacao === dados.situacao)
      setData(filteredData)
      return
    }
  }

  useEffect(() => {
    getOrdemProduction({
      situacao: '3',
    })
  }, [])

  const getClientHeight = window.innerHeight * 0.75

  const getTableHeight = getClientHeight - 15

  const contadorPedidosIguais = data.filter((item, index, self) => self.findIndex((t) => t.numero_pedido === item.numero_pedido) === index).length

  return (
    <>
      <HeadingPages name="Ordem produção" />

      <Flex marginBlock={'1rem'} alignItems={'center'} justifyContent={'center'}>
        {/*<Input type={"number"} placeholder={"Número do pedido"} />*/}
        {/*<Input type={"text"} placeholder={"Impressão"} />*/}
        <Filtro getOrdemProduction={getOrdemProduction} />
      </Flex>

      <Flex alignItems={'center'} justifyContent={'space-between'}>
        <Button
          onClick={() => generatePDF(data)}
          mb={'1rem'}
          _focus={{
            outline: 'none',
          }}
        >
          Gerar PDF
        </Button>

        <Text fontSize={'0.8rem'} fontWeight={'bold'}>
          Total de pedidos: {contadorPedidosIguais}
        </Text>
        <Flex flexDir="column" alignItems="flex-start" gap={2}>
          <Flex>
            <OpsLiberadas ops={infoModalOps} />
            <Button _focus={{ outline: 'none' }} mr={'1rem'} onClick={finalizeCheckout} isDisabled={checkoutItem.length === 0}>
              Finalizar todos
            </Button>
          </Flex>
          <Button
            mb={'1rem'}
            mr={'1rem'}
            _focus={{ outline: 'none' }}
            onClick={handleCheckoutAllItems}
            isLoading={loadingCheckoutAllItems}
            alignSelf="flex-end"
          >
            {checkoutItem.length === data.length ? 'Desmarcar todos' : 'Marcar todos'}
          </Button>
        </Flex>
      </Flex>

      <TableContainer textAlign="center" overflowY="auto" overflow="auto" height={getTableHeight}>
        <Table variant="simple" colorScheme="gray" fontSize="0.7rem" size={'sm'}>
          <Thead textAlign="center" px="6rem" position="sticky" top="0" zIndex="1">
            <Tr bg="#378BBF" color="white" mx="6rem">
              <S.Th>nº Pedido</S.Th>
              <S.Th>Empresa</S.Th>
              <S.Th>Ped Compra</S.Th>
              <S.Th>Vendedor</S.Th>
              <S.Th>Descrição</S.Th>
              <S.Th>Cod. Prod</S.Th>
              <S.Th>Cor produto</S.Th>
              <S.Th>Qtd</S.Th>
              <S.Th>Gravação</S.Th>
              <S.Th>OBS OP</S.Th>
              <S.Th>Prazo</S.Th>
              <S.Th>
                Término <br /> Produção
              </S.Th>
              <S.Th>O.P.</S.Th>
              <S.Th>Link layout</S.Th>
              <S.Th>Dados Váriaveis</S.Th>
              <S.Th>Layout Terceirizado</S.Th>
              <S.Th>O.P. Integrada</S.Th>
              <S.Th>Situação</S.Th>
              <S.Th>Confirmar</S.Th>
            </Tr>
          </Thead>
          <Tbody>
            {loading && (
              <Tr>
                <Td colSpan={15}>
                  <Flex alignItems={'center'} justifyContent={'center'}>
                    <Spinner size={'xl'} />
                  </Flex>
                </Td>
              </Tr>
            )}
            {!loading && data.map((item, index) => <Row key={index} item={item} handleCheckoutItem={handleCheckoutItem} />)}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  )
}
